import React from "react";
import { motion } from "framer-motion";
import { PHILOSOPHY } from "../content";

export default function Philosophy() {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="relative section-pad"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <div className="text-[#27C6FF] uppercase tracking-[0.3em] text-xs mb-5 font-heading">
            Logo Philosophy
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
            Four symbols.
            <br />
            <span className="gradient-text">One transformation.</span>
          </h2>
          <p className="mt-6 text-[#D8CCFF] text-base md:text-lg font-body">
            Every part of the DietDotIn mark stands for a pillar we coach on
            every single day.
          </p>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PHILOSOPHY.map((p, i) => (
            <motion.div
              key={p.key}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              whileHover={{ y: -6 }}
              className="relative glass rounded-3xl overflow-hidden group"
              data-testid={`philosophy-card-${p.key}`}
            >
              <div className="aspect-[4/5] relative">
                <img
                  src={p.img}
                  alt={`${p.title} — symbolising ${p.sub.toLowerCase()} at DietDotIn`}
                  className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#140326] via-[#140326]/55 to-transparent" />
                <div className="absolute inset-0 bg-gradient-to-tr from-[#7A2BFF]/0 via-transparent to-[#27C6FF]/10 group-hover:from-[#7A2BFF]/25 group-hover:to-[#27C6FF]/25 transition-all duration-500" />
              </div>
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <div className="text-[#27C6FF] uppercase tracking-[0.25em] text-[10px] font-heading">
                  {p.sub}
                </div>
                <h3 className="font-display font-bold text-3xl text-white mt-1">
                  {p.title}
                </h3>
                <p className="mt-3 text-[#D8CCFF] text-sm leading-relaxed">
                  {p.desc}
                </p>
              </div>
              <div className="absolute -top-12 -right-12 w-32 h-32 bg-[#7A2BFF]/40 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
